import { buttonVariants } from "@repo/ui/components/ui/button"
import { Body, H1 } from "@repo/ui/components/ui/typography"
import { cn } from "@repo/ui/lib/utils"
import { Link } from "@tanstack/react-router"
import { Home } from "lucide-react"

function Default404() {
  return (
    <div className="flex flex-col items-center justify-center size-full gap-2 p-6 text-center md:gap-4">
      <div className="space-y-2">
        <H1 weight="bold" className="text-3xl sm:text-4xl">
          404.
        </H1>
        <Body className="text-muted-foreground">
          Den här sidan existerar inte längre.
        </Body>
      </div>
      <div className="flex gap-2">
        <Link to="/" className={cn(buttonVariants({ variant: "default" }))}>
          <Home className="size-4 mr-0.5" />
          Gå till startsidan
        </Link>
      </div>
    </div>
  )
}
export default Default404
